export const idx_data_bowler_style = [];

idx_data_bowler_style.push({
  style: '',
  order_idx: -1,
});

idx_data_bowler_style.push({
  style: 'tradicional',
  order_idx: 0,
});

idx_data_bowler_style.push({
  style: 'two-handed',
  order_idx: 1,
});

idx_data_bowler_style.push({
  style: 'spinner',
  order_idx: 2,
});

idx_data_bowler_style.push({
  style: 'backup',
  order_idx: 3,
});